import type { MakolabInsuranceResponseType, ParsedInsuranceRateType } from "../../types/FinanceInsuranceRateTypes";
import Debug from "../../../../common-deprecated/Debug";
import { calcFind, formatLegalText } from "./formatFinance";
import type { LegalTextResponseType } from "../../types/FinanceTypes";

export const formatInsurance = (
    insuranceRate: MakolabInsuranceResponseType,
    legalText: LegalTextResponseType,
): ParsedInsuranceRateType => {
    const response: Partial<ParsedInsuranceRateType> = {};

    const calculations = insuranceRate?.Quotation?.Calculations?.Calculation;

    response.legalText = formatLegalText(legalText);

    let total: string | null = null;
    if (calculations?.length) {
        total =
            calcFind(calculations, "INTEGRATED_CAR_CONFIG_PREMIUM") ||
            calcFind(calculations, "MONTHLY_TOTAL_INSURANCE_AMOUNT");

        response.quoteInfo = {};
        calculations.forEach((calc) => {
            response.quoteInfo![calc.Name] = { value: calc.Value, formatted: calc.Formatted };
        });
    } else {
        Debug.error("No calculations found in insurance rate response");
    }

    response.total = Number(total) || 0;
    response.name = insuranceRate?.Quotation?.Product_Name;
    return response as ParsedInsuranceRateType;
};
